module.exports = __webpack_public_path__ + "img/DSC_9182.19884529.jpg";